/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_Scope_GlobalInputs */

const en_enum_entity_scope_global = /** @type {(inputs: Enum_Entity_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

const de_enum_entity_scope_global = /** @type {(inputs: Enum_Entity_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

/**
* | output |
* | --- |
* | "Global" |
*
* @param {Enum_Entity_Scope_GlobalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_entity_scope_global = /** @type {((inputs?: Enum_Entity_Scope_GlobalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_Scope_GlobalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_scope_global(inputs)
	return de_enum_entity_scope_global(inputs)
});